import { render, staticRenderFns } from "./InviteStatusChip.vue?vue&type=template&id=177b720a"
import script from "./InviteStatusChip.vue?vue&type=script&lang=js"
export * from "./InviteStatusChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports